import {createApp} from 'vue'
import App from './App.vue'
import axios from 'axios'

//globals
import InlineSvg from 'vue-inline-svg'

//state
import {store} from './store'

//routes
import VueGtag from "vue-gtag-next"
import router from './router'

//templates
import Generic from "@/components/pages/Generic"
import Home from "@/components/pages/Home"
import Mission from "@/components/pages/Mission"
import Visionaries from "@/components/pages/Visionaries"
import VisionariesDetail from "@/components/pages/VisionariesDetail"
import Storytelling from "@/components/pages/Storytelling"
import Resources from "@/components/pages/Resources"
import ResourcesDetail from "@/components/pages/ResourcesDetail"
import Contact from "@/components/pages/Contact"
import NewsDetail from "@/components/pages/NewsDetail"

//GLOBAL CONFIG
window.siteConfig = {}

let craftApiPreviewToken = ''
const urlParams = new URLSearchParams(window.location.search)
if (urlParams.get('token')) {
    craftApiPreviewToken = '?' + urlParams.toString()
}
window.config = {
    metaTitleAddon: "InMaat Foundation",
    loadedOnce: false,
    routerInTransition: false,
    apiroot: process.env.VUE_APP_API,
    apiext: (process.env.VUE_APP_API === '/local-temp/api/') ? '.json' : craftApiPreviewToken,
    localMode: (process.env.VUE_APP_API === '/local-temp/api/' || window.siteConfig?.xCraftLivePreview),
    json: {
        global: null
    },
}
axios.get((`${window.config.apiroot}global${window.config.apiext}`))
    .then((res) => {
        //GLOBAL CONFIG
        window.config.json.global = res.data

        //DYNAMIC ROUTES
        for (let i = 0; i < res.data.routes.length; i++) {
            let obj = res.data.routes[i]
            let newobj = {
                path: obj.path,
                meta: {
                    title: obj.title,
                    type: obj.type,
                    headerTheme: obj.headerTheme
                },
            }
            switch (obj.type) {
                case 'home':
                    newobj.component = Home
                    break
                case 'generic':
                    newobj.component = Generic
                    break
                case 'mission':
                    newobj.component = Mission
                    break
                case 'visionaries':
                    newobj.component = Visionaries
                    break
                case 'visionaries-detail':
                    newobj.component = VisionariesDetail
                    break
                case 'storytelling':
                    newobj.component = Storytelling
                    break
                case 'storytelling-detail':
                    newobj.component = Storytelling
                    break
                case 'resources':
                    newobj.component = Resources
                    break
                case 'resources-detail':
                    newobj.component = ResourcesDetail
                    break
                case 'contact':
                    newobj.component = Contact
                    break
                case 'news-detail':
                    newobj.component = NewsDetail
                    break
            }
            router.addRoute(newobj)
        }


        //page not found
        let newobj = {
            name: 'page-not-found',
            path: "/:catchAll(.*)",
            component: Generic,
            meta: {
                title: 'Page Not Found'
            }
        }
        router.addRoute(newobj)

        //START APP
        startApp()
    }).catch(() => {
})

function startApp () {
    //LOAD
    const app = createApp(App)
    app.use(router)
    app.use(store)


    //ANALYTICS - in your main.js, below loading your router
    if (window.location.hostname !== "localhost") {
        app.use(VueGtag, {
            property: {
                id: window.config.json.global.config.googleAnalyticsId
            }
        })
    }

    //global inline svg
    app.component('inline-svg', InlineSvg)

    app.mount('#app')
}
